import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategoriesSection from "./components/CategoriesSection";
import AboutSection from "./components/AboutSection";
import ComparisonSection from "./components/ComparisonSection";
import FAQSection from "./components/FAQSection";
import ArticlesSection from "./components/ArticlesSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import SEOHead from "@/components/base/SEOHead";

const SITE_URL = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://oopbuyspreadsheet.work';

function buildHomeJsonLd() {
  return [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "OOPBuy Spreadsheet",
      "url": SITE_URL,
      "description": "The OOPBuy spreadsheet is a structured and regularly updated product sourcing database designed to help users quickly find verified product lists, compare alternatives, and access organized data for smarter decision-making.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${SITE_URL}/?q={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "OOPBuy Spreadsheet",
      "url": SITE_URL,
      "description": "A digital product sourcing system that organizes listings, supplier data, and product comparisons into structured spreadsheets.",
      "sameAs": [
        "https://kaspreadsheet.com/"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is OOPBuy spreadsheet used for?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The OOPBuy spreadsheet is used for organizing product sourcing data, comparing listings, and accessing structured product information."
          }
        },
        {
          "@type": "Question",
          "name": "Is OOPBuy spreadsheet free?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Many OOPBuy spreadsheet resources are free to access, but availability depends on the provider."
          }
        },
        {
          "@type": "Question",
          "name": "Is OOPBuy spreadsheet legit?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The OOPBuy spreadsheet is a data organization tool. Its reliability depends on the source maintaining updated and verified information."
          }
        },
        {
          "@type": "Question",
          "name": "How often is OOPBuy spreadsheet updated?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most OOPBuy spreadsheet systems are updated regularly, depending on the data provider or community maintenance cycle."
          }
        },
        {
          "@type": "Question",
          "name": "What is the alternative to OOPBuy spreadsheet?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Alternatives include manual sourcing, supplier databases, or other spreadsheet-based product tracking systems."
          }
        }
      ]
    }
  ];
}

export default function Home() {
  return (
    <main>
      <SEOHead
        title="OOPBuy Spreadsheet – Updated Product Database, Guide & Verified Lists 2026"
        description="The OOPBuy spreadsheet is a structured and regularly updated product sourcing database. Access verified product lists, compare alternatives, and explore organized category data for smarter decisions in 2026."
        keywords="oopbuy spreadsheet, oopbuy spreadsheet guide, oopbuy spreadsheet database, oopbuy spreadsheet 2026, product sourcing spreadsheet"
        canonicalPath="/"
        ogType="website"
        jsonLd={buildHomeJsonLd()}
      />
      <Navbar />
      <Hero />
      <CategoriesSection />
      <AboutSection />
      <ComparisonSection />
      <FAQSection />
      <ArticlesSection />
      <CTASection />
      <Footer />
    </main>
  );
}